import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) { toast.error('Complete los campos obligatorios'); return; }
    if (form.password.length < 6) { toast.error('La contraseña debe tener al menos 6 caracteres'); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success('Cuenta creada exitosamente');
      navigate('/tienda');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8">
          <div className="mb-8">
            <h1 className="text-2xl font-display font-semibold tracking-tight">Crear Cuenta</h1>
            <p className="text-sm text-muted-foreground mt-1">Regístrate para comprar en KIND TECHNOLOGIES</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
            <div className="space-y-2">
              <Label>Nombre completo *</Label>
              <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Tu nombre" data-testid="register-name" />
            </div>
            <div className="space-y-2">
              <Label>Correo electrónico *</Label>
              <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="correo@ejemplo.com" data-testid="register-email" />
            </div>
            <div className="space-y-2">
              <Label>Teléfono</Label>
              <Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+52 55..." />
            </div>
            <div className="space-y-2">
              <Label>Contraseña *</Label>
              <Input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Mínimo 6 caracteres" data-testid="register-password" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit">
              {loading ? 'Registrando...' : 'Crear Cuenta'}
            </Button>
          </form>
          <p className="text-sm text-center text-muted-foreground mt-6">
            ¿Ya tienes cuenta? <Link to="/login" className="text-foreground font-medium hover:underline">Inicia Sesión</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
